export default __webpack_public_path__ + "static/ai-solutions-with-roadmap1-0a18a6ae3c2d68b706542ed29eec42cd.jpg";